import styled, { css } from 'styled-components'

import A from '../A'
import { mq, sizes } from '../../theme'

export const Container = styled.div``
export const Tag = styled(A)<{
  $textColor?: string
  $backgroundColor?: string
  isActive?: boolean
  disabled?: boolean
}>`
  display: inline-flex;
  justify-content: center;
  align-items: center;
  text-decoration: none;
  height: 3.4rem;
  padding: 0.2rem 1rem;
  border-radius: 3.4rem;
  border: 2px solid
    ${({ $backgroundColor, theme }) =>
      $backgroundColor ?? theme.colors.greenApple ?? 'green'};
  font-size: 1.6rem;
  white-space: nowrap;
  color: ${({ theme, isActive, $textColor }) =>
    $textColor
      ? $textColor
      : isActive === true
      ? theme.colors.pureWhite ?? 'white'
      : theme.colors.pureBlack ?? 'black'};
  background-color: ${({ theme, isActive, $backgroundColor }) =>
    isActive === true
      ? $backgroundColor ?? theme.colors.greenApple ?? 'green'
      : theme.colors.pureWhite ?? 'white'};
  &.is-link:hover {
    color: ${({ theme }) => theme.colors.pureWhite ?? 'white'};
    background-color: ${({ $backgroundColor, theme }) =>
      $backgroundColor ?? theme.colors.greenApple ?? 'green'};
  }

  @media ${mq(sizes.desktop)} {
    font-size: 1.8rem;
    border-radius: 3.4rem;
  }

  ${({ disabled }) =>
    disabled &&
    css`
      box-shadow: 0 none;
      opacity: 0.5;
      cursor: not-allowed;
    `}
`

export const TagText = styled.span``
